import { render, staticRenderFns } from "./ProductBreadcrumb.vue?vue&type=template&id=4a8dd2d6&"
import script from "./ProductBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./ProductBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./ProductBreadcrumb.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports